import PurchaseGiftManager from '@/components/purchase-gift-manager';

window.PurchaseGiftManager = new PurchaseGiftManager(window?.theme?.gift_product);
